// Module
import htmlOneAccount from './one-account.html'
import { callApi } from '@local_modules/generic/fetch.js'
import { fillString } from '@local_modules/generic/string-template.js'
import { applyRestrictions } from '../../../../modules/user/html-parser.js'
import { setElementHtml } from '../../../../helpers/generic-js/dom.js'

export async function showUserAccounts (containerElementId) {
  setElementHtml(containerElementId, `
      <div>
        <progress class="progress is-small is-info" max="100">Loading</progress>
      </div>
      `)

  const appAccountsOfUser = await getUserAccounts()

  outputList({
    appAccountsOfUser,
    containerElementId
  })
}

async function getUserAccounts () {
  const apiUrl = '/api/app-account/list'
  const responseData = await callApi(apiUrl)
  console.log('getUserAccounts response', responseData)

  return responseData.appAccountsOfUser
}

function outputList (params) {
  console.log('outputList', params)
  const { appAccountsOfUser, containerElementId } = params

  const listContainerElement = document.getElementById(containerElementId)
  if (!listContainerElement) return

  if (!appAccountsOfUser) {
    listContainerElement.innerText = 'No accounts found'
    return
  }

  listContainerElement.innerText = ''

  appAccountsOfUser?.forEach(function (oneAppAccount) {
    const oneAccountHtml = generateOneAccountHtml(oneAppAccount)
    listContainerElement.insertAdjacentHTML('beforeend', oneAccountHtml)
  })
}

function generateOneAccountHtml (oneAppAccount) {
  console.log('generateOneAccountHtml', oneAppAccount)

  const appUrlToAccount = fillString('/app/acc/:appAccountId', {
    appAccountId: oneAppAccount.id
  })

  // Using HTML Template
  let oneAccountHtml = fillString(htmlOneAccount, {
    accountId: oneAppAccount.id,
    appAccountId: oneAppAccount.id,
    accountName: oneAppAccount.name,
    userRights: oneAppAccount.rights?.map(function (oneRight) {
      return `<span class="tag">${oneRight}</span>`
    }).join(''),
    // linkToXeroSettings: appUrlToXeroSettings,
    linkToAccountSettings: appUrlToAccount
  })

  oneAccountHtml = applyRestrictions(oneAccountHtml, { accountData: oneAppAccount })

  return oneAccountHtml
}
